"use strict";var r=require("../Guard/isString.cjs");exports.isNonEmptyString=function(t){return r.isString(t)&&t.length>0};
//# sourceMappingURL=isNonEmptyString.cjs.map
